module.exports = __webpack_public_path__ + "static/media/agile.b259b407.png";